<template>
  <label
    class="block font-mono text-xxs text-gray-500 uppercase tracking-wider"
    :class="noMargin ? 'mb-0' : 'mb-4'"
    @click="$emit('click', $event)"
  >
    <slot />
  </label>
</template>

<script>
export default {
  name: 'LmLabel',
  props: {
    noMargin: {
      type: Boolean,
      default: false
    }
  }
}
</script>
